import { Component, Input } from '@angular/core';

@Component({
  selector: 'info-tooltip',
  templateUrl: './tooltip.component.html',
  styleUrls: ['./tooltip.component.scss'],
  standalone: false,
})
export class TooltipComponent {
  showTooltip = false;
  @Input() tooltipText: string;

  onMouseEnter() {
    this.showTooltip = true;
  }

  onMouseLeave() {
    this.showTooltip = false;
  }
}
